/**
 * 検索ページのフォームに関する処理
 * @returns { void }
 */
export const searchForm = () => {
  const searchFormHeader = $( '.p-search-form__header' );

  searchFormHeader.on( 'click', function () {
    $(this).toggleClass( 'is--open' );
    if ( $(this).hasClass( 'is--open' ) ) {
      $(this).next().stop().slideDown();
    } else {
      $(this).next().stop().slideUp();
    }
  } );
}
